import { render, staticRenderFns } from "./DialogNovaEmpresa.vue?vue&type=template&id=040543e8&scoped=true&"
import script from "./DialogNovaEmpresa.vue?vue&type=script&lang=js&"
export * from "./DialogNovaEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040543e8",
  null
  
)

export default component.exports